<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="18" height="14" rx="2.5" :stroke="fill" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7 5.5L7 6M7 18.5L7 18M7 14.999L7 15M7 11.999L7 12M7 8.999L7 9" :stroke="fill" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  props: {
    width: {
      default: 24,
    },
    height: {
      default: 24,
    },
    fill: {
      default: "currentColor",
    },
    viewBox: {
      default: "0 0 24 24",
    },
    disabled: {
      default: false,
    },
  },
})
</script>
